import { createRouter, createWebHistory } from 'vue-router'

import { routes } from '@/app/router/routes'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  /*
   * 뒤로/앞으로(popstate)면 이전 스크롤 위치를 복원하고, 그 외에는 최상단으로 간다.
   * 메뉴 상세를 보고 목록으로 돌아왔을 때 보던 위치가 유지된다.
   *
   * savedPosition은 즉시 적용하면 목록이 아직 렌더되지 않아(매장 데이터는 캐시라 곧 그려진다)
   * 문서 높이가 모자라 원하는 위치까지 못 내려간다. 한 프레임 뒤 복원한다.
   */
  scrollBehavior(_to, _from, savedPosition) {
    if (!savedPosition) return { top: 0 }
    return new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(() => resolve(savedPosition)))
    })
  },
})

/*
 * ★?code= (일본 업체 구분 코드) 유지.
 *
 * QR 최초 진입 시 URL에 실려 오고, 이후 모든 페이지 이동에 계속 붙어 있어야 한다
 * (주문 payload·소프트뱅크 복귀 URL·배달 상세주소 접두에 쓰인다). 하지만 router-link/
 * router.push 대부분이 쿼리를 싣지 않아 유실됐다. 첫 code를 기억해 두고, code가 빠진
 * 이동마다 같은 위치로 code를 붙여 리다이렉트한다(같은 URL이라 히스토리도 오염되지 않는다).
 *
 * 페이지 새로고침 시 모듈이 초기화되므로, 그때는 그 시점 URL의 code를 다시 기준으로 삼는다.
 */
let preservedCode: string | undefined

router.beforeEach((to) => {
  /*
   * /q/:licenseKey(QR 진입)와 /kakao-registration(등록완료)은 매장등록 흐름으로, 라이선스 키는 경로 파라미터로 들어온다.
   * 여기서 다루는 배달코드 ?code= 와는 무관하므로, 혹시 남아있던 배달코드가
   * 등록 URL·이후 이동에 따라붙지 않도록 등록 경로는 보존/적용 대상에서 제외한다.
   */
  if (to.path.startsWith('/q/') || to.path === '/kakao-registration') return true

  const incoming = typeof to.query.code === 'string' ? to.query.code : undefined
  if (incoming != null) {
    preservedCode = incoming
    return true
  }
  if (preservedCode != null) {
    return { path: to.path, query: { ...to.query, code: preservedCode }, hash: to.hash }
  }
  return true
})

export default router
